import { render, staticRenderFns } from "./FundTable.vue?vue&type=template&id=13bb446a&scoped=true"
import script from "./FundTable.vue?vue&type=script&lang=js"
export * from "./FundTable.vue?vue&type=script&lang=js"
import style0 from "./FundTable.vue?vue&type=style&index=0&id=13bb446a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bb446a",
  null
  
)

export default component.exports